import { render, staticRenderFns } from "./world.vue?vue&type=template&id=66cd0fd0&scoped=true&"
import script from "./world.vue?vue&type=script&lang=js&"
export * from "./world.vue?vue&type=script&lang=js&"
import style0 from "./world.vue?vue&type=style&index=0&id=66cd0fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd0fd0",
  null
  
)

export default component.exports